import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { FaEnvelope, FaPhoneAlt, FaInstagram } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

import post1 from "./Images/img1.jpg";
import post2 from "./Images/img2.jpg";
import post3 from "./Images/img3.jpg";
import post4 from "./Images/img4.jpg";
import logo from "./Images/vad_logo1.png";

const images = [post1, post2, post3, post4];

const ComingSoon = () => (
  <Container className="d-flex align-items-center justify-content-center">
    <Row className="w-100">
      <Col className="text-left d-flex flex-column align-items-start justify-content-center">
        <img
          src={logo}
          alt="Logo"
          className="img-fluid"
          style={{ maxWidth: "250px" }}
        />
        <h1 className="fw-bold" style={{ fontFamily: "outfit", letterSpacing: "2px" }}>Coming Soon !!</h1>
        <p className="text-left fs-5" style={{ fontFamily: "outfit" }}>
          Elevate your spaces with <strong>VAD Architects</strong>—your destination for
          <strong> Architecture, Landscape, Interior Design, and Turnkey Execution</strong>.
          We blend <em>innovation</em> with <em>functionality</em>, turning visions into reality.
        </p>
        <p className="text-left fst-italic" style={{ fontFamily: "outfit" }}>"Designing spaces that inspire and endure."</p>
        <p className="fw-bold text-left" style={{ fontFamily: "outfit" }}>Founder: <span className="text-primary" style={{ fontFamily: "outfit" }}>Ar. Viraj Daspute</span></p>
        <p className="text-left" style={{ fontFamily: "outfit" }}>
          <strong>Visit us:</strong> A-602, Ganesh Gunjan Apt, near City Center Mall, Nashik, Maharashtra 422009
        </p>
        <div className="d-flex gap-3">
          <a href="mailto:architectsvad@gmail.com" className="text-dark fs-4">
            <FaEnvelope />
          </a>
          <a href="tel:+918956675635" className="text-dark fs-4">
            <FaPhoneAlt />
          </a>
          <a href="https://www.instagram.com/v.a.d_architects_/#" target="_blank" rel="noopener noreferrer" className="text-dark fs-4">
            <FaInstagram />
          </a>
        </div>
      </Col>
      <Col md={6} xs={12}>
        <Carousel className="mt-4 mb-4">
          {images.map((src, index) => (
            <Carousel.Item key={index}>
              <img className="d-block w-100" src={src} alt={`Slide ${index + 1}`} />
            </Carousel.Item>
          ))}
        </Carousel>
        
      </Col>
    </Row>
  </Container>
);

export default ComingSoon;